import Dict from '@/utils/dict-utils'

// 保函审批状态
export const onlineLetterApprovalStatusDict = new Dict({
  APPLYING: { label: '申请中', value: 1, type: 'primary' },
  APPROVAL: { label: '申请中', value: 2, type: 'primary' },
  SUCCESS: { label: '已开立', value: 3, type: 'success' },
  FAILED: { label: '开立失败', value: 4, type: 'danger' }
})

// 保函订单状态
export const onlineLetterOrderStatusDict = new Dict({
  NOT_EXPIRED: { label: '未过期', value: 0 },
  SURRENDERING: { label: '退回保函中', value: 1 },
  SUCCESS: { label: '退保成功', value: 2 },
  FAILED: { label: '退保失败', value: 3 },
  CANCELED: { label: '取消退保', value: 4 }
})

// 保函发票申请状态
export const onlineLetterInvoiceStatusDict = new Dict({
  APPLYING: { label: '申请中', value: 0 },
  SUCCESS: { label: '申请成功', value: 1 },
  FAILED: { label: '申请失败', value: 2 }
})
